import { useEffect } from 'react'

function usePreloadImages(srcs) {
    useEffect(() => {
        srcs.forEach(src => {
            const img = new Image()
            img.src = src
        })
    }, [])
}

export default usePreloadImages